import { callGetApi } from '../apiCallerProxy';
import { createHighImpactTargetingApi } from './highImpactTargetingFactory';

export * from './hooks';
export default createHighImpactTargetingApi({ callGetApi });
